import { FaIcon } from "./FaIcon";

export const EmbedPopup: FaIcon.Icon = {
  icon: [300, 300, [], "", "M60 60 h180 v180 h-180 z"]
};
